import { createContext, useContext, useEffect, useState } from "react";
import { jwtDecode } from "jwt-decode";
import { fetchUserById } from "./usersService";


const AuthContext = createContext({
  user: null,
  loading: true,
});

const parseIds = (val) => {
  if (!val) return [];
  if (Array.isArray(val)) return val.map(String);
  if (typeof val === "string") {
    try {
      const parsed = JSON.parse(val);
      return Array.isArray(parsed) ? parsed.map(String) : [String(val)];
    } catch {
      return [val];
    }
  }
  return [String(val)];
};

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const refreshUser = async () => {
    if (!user?.userId) return;

    const res = await fetchUserById(user.userId);
    const userData = res?.data?.data ?? res?.data ?? res;

    setUser((prev) => ({
      ...prev,
      organizationIds: parseIds(userData.attributes?.swaggerOrganizationIds),
      projectIds: parseIds(userData.attributes?.swaggerProjectIds || userData.attributes?.swaggerProjectIdss),
    }));
  };



  useEffect(() => {
    const token = localStorage.getItem("access_token");

    if (!token) {
      setUser(null);
      setLoading(false);
      return;
    }

    try {
      const decoded = jwtDecode(token);

      const roles = decoded?.resource_access?.swagger?.roles || [];

      const userId = decoded?.sub || null;

      const organizationIds = parseIds(decoded?.swaggerOrganizationIds);
      const projectIds = parseIds(decoded?.swaggerProjectIds || decoded?.swaggerProjectIdss);
      const username = decoded?.preferred_username || "User";


      setUser({
        userId,
        roles,
        username,
        organizationIds,
        projectIds,
      });
    } catch (err) {
      console.error("Invalid token", err);
      setUser(null);
    } finally {
      setLoading(false);
    }
  }, []);

  return (
    <AuthContext.Provider value={{ user, loading, refreshUser }}>
      {children}
    </AuthContext.Provider>

  );
};

export const useAuth = () => useContext(AuthContext);
